import styled from "styled-components";

export const Wrapper = styled("div")(({ theme, $isShowInSmallScreen }) => ({
  ...($isShowInSmallScreen ? { display: "none" } : { display: "flex" }),
  flexDirection: "column",

  [theme.down("lg")]: {
    ...($isShowInSmallScreen ? { display: "flex" } : { display: "none" }),
  },
}));

export const SupportButton = styled("button")(({ theme }) => ({
  ...theme.mixins.flexCenterCenter,
  gap: 8,
  border: "1px solid #cbd5e1",
  borderRadius: 4,
  backgroundColor: "transparent",
  color: "#475569",
  fontSize: 16,
  fontWeight: 600,
  transition: "all .3s ease-out",
  height: 46,
  width: "100%",
  cursor: "pointer",

  "&:hover": {
    borderColor: theme.palette.searchButtonBg,
    color: theme.palette.searchButtonBg,
  },

  "& svg": {
    fontSize: 20,
  },
}));
